import React, { useContext, useRef, useState } from 'react';
import { Select } from 'antd';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { useMutation, useQuery } from 'react-query';
import { FirebaseContext } from '../../context/FirebaseContext';
import { getDCBReports, getReports } from '../../NecttosComp/APICaller/ApiServices';
import LoadingAnimation from '../../components/LoadingAnimation';
import { useAccountsHeads, useAllClasses } from '../../NecttosComp/APICaller/queryHooks';
import moment from 'moment';
import Instruction from '../../Documentation/Instruction';
import { Body, Header, Main } from '../../NecttosComp/Layout/Layout';
import Input2 from '../../NecttosComp/Input/Input2';
import Button from '../../NecttosComp/Button/Button';
import { Table, Tbody, Td, Th, Thead, Tr } from '../../NecttosComp/Table/Table';

export const exportPdfCollectionReport = async ({ postData, setLoading, setAlert }) => {
	const instance = await getAxiosTokenInstance();

	try {
		const resp = await instance.post(`/college/reportGeneration/generateCollectionReport`, postData, {
			responseType: 'blob',
		});

		if (resp.data.statusCode === 400) {
			throw new Error(resp.data.message || 'API Error');
		} else {
			return resp.data;
		}
	} catch (e) {
		throw new Error(
			setLoading(false),
			setAlert({
				type: 'Message',
				text: 'Chack Date / Time / Main account / Sub account',
				show: true,
			}),
		);
	}
};

export const FDCB = ({ onClose }) => {
	const allClasses = useAllClasses({ needAll: false, classOnly: false });
	const [state, setState] = React.useState({
		startDate: '',
		endDate: '',
		startTime: '',
		endTime: '',
		mainAccount: '',
		subAccount: '',
		activeStatus: '',
		lactive: true,
	});

	const [alert, setAlert] = React.useState({
		type: 'error',
		text: 'This is a alert message',
		show: false,
	});
	const accounts = useAccountsHeads();
	const { collegeId, collegeList } = useContext(FirebaseContext);
	const componentRef = useRef();
	const selectedCollege = collegeList?.find((x) => x.collegeId === collegeId);
	const onCloseAlert = () => {
		setAlert({
			type: '',
			text: '',
			show: false,
		});
	};
	let quaryData = {
		startDate: state?.startDate,
		endDate: state?.endDate,
		mainAccount: state?.mainAccount || '',
		subAccount: state?.subAccount || '',
		method: state?.method || '',
		classId: state?.classId || '',
		activeStatus: state?.activeStatus || '',
		collegeId,
		state,
	};
	const { data = [], isLoading, refetch } = useQuery(['getDCBReports', state.mainAccount, state?.activeStatus, state?.subAccount, state?.method, state?.startDate, state?.endDate, state?.classId, state], getDCBReports(quaryData));

	const [loading, setLoading] = useState(false);

	let subAccount = accounts?.data?.subAccounts || [];
	let mainAccount = accounts?.data?.mainAccounts || [];
	if (state?.mainAccount) {
		subAccount = subAccount.filter((x) => x.mainId === state?.mainAccount);
	}
	const { Option } = Select;

	const exportPdfMutationDateCollectionReport = useMutation(exportPdfCollectionReport);

	const onDateCollectionReport = async () => {
		setLoading(true);
		try {
			const link = document.createElement('a');
			link.target = '_blank';
			let postData = {
				startDate: state?.startDate,
				endDate: state?.endDate,
				startTime: state?.startTime,
				endTime: state?.endTime,
				mainAccount: state?.mainAccount || '',
				subAccount: state?.subAccount || '',
				method: state?.method || '',
				activeStatus: state?.activeStatus || '',
				collegeId,
			};
			link.download = state?.endDate;
			const pdfData = await exportPdfMutationDateCollectionReport.mutateAsync({ postData, setLoading, setAlert });
			link.href = URL.createObjectURL(new Blob([pdfData], { type: 'application/pdf' }));
			link.click();
			setLoading(false);
		} catch (e) {}
	};

	const columns = [
		{
			title: 'Class Name',
			dataIndex: 'className',
			key: 'className',
		},
		{
			title: 'Student Name',
			dataIndex: 'userName',
			key: 'userName',
		},
		{
			title: 'Admn No',
			dataIndex: 'admisionNo',
			key: 'admisionNo',
		},
		{
			title: 'E GRAND',
			dataIndex: 'eGrand',
			key: 'eGrand',
		},
		{
			title: 'Opening Balance',
			dataIndex: 'openingBalance',
			key: 'openingBalance',
		},
		{
			title: 'Current Collection',
			dataIndex: 'currentCollection',
			key: 'currentCollection',
		},
		{
			title: 'Clossing Balance',
			dataIndex: 'clossingBalance',
			key: 'clossingBalance',
		},
	];

	subAccount = subAccount.concat({ label: 'All', value: '' });
	return (
		<Main title='FDCB REPORT' width='100%' height='100%'>
			<Header width='100%'>
				<div className='w-full flex '>
					<Input2 className='w-[150px] mt-4' type='date' returnKey='startDate' fieldName='Start Date' state={state} setState={setState} />
					<Input2 className='w-[150px] mt-4' type='date' returnKey='endDate' fieldName='End Date' state={state} setState={setState} />

					<Input2 className='w-[200px] mt-4' type='drop' fieldName='Class' returnKey='classId' optionDisplay='label' optionKey='value' options={(allClasses?.data || []).map((x, i) => ({ 
						    label: x.className || '',
							value: x.className + i,
							extra: x,
						}))}
						state={state}
						setState={setState}
					/>

					<Input2 className='w-[200px] mt-4' type='drop' fieldName='Main Account' returnKey='mainAccount' optionDisplay='label' optionKey='value' options={(mainAccount || []).map((x) => ({
							label: x.label || '',
							value: x.value || '',
						}))}
						state={state}
						setState={setState}
						didntShowKey
					/>

					<Input2 className='w-[200px] mt-4' type='drop' fieldName='Sub Account' returnKey='subAccount' optionDisplay='label' optionKey='value'
						options={(subAccount || []).map((x) => ({
							label: x.label || '',
							value: x.value || '',
						}))}
						state={state}
						setState={setState}
						didntShowKey
					/>

					<Input2 className='w-[200px] mt-4' type='drop' fieldName='Methods' returnKey='method' optionDisplay='label' optionKey='value'
						options={['Online', 'Normal'].map((x) => ({
							label: x,
							value: x,
						}))}
						state={state}
						setState={setState}
					/>

					<Input2 className='w-[200px]' type='mdrop' fieldName='Active Status' returnKey='activeStatus'
						optionDisplay='label'
						optionKey='value'
						options={['active', 'Discontinued', 'Suspended', 'Dismissed', 'Long Leave', 'TC Issue', 'College Transfer', 'Irregular'].map((x) => ({
							label: x.toUpperCase(),
							value: x,
						}))}
						state={state}
						setState={setState}
					/>
				</div>

				<div className='relative '>
					<div className=''></div>
					<div className='absolute right-10 top-10 flex items-end justify-end'>
						<Button type='close' onClick={() => refetch()}>
							View
						</Button>
						<Button type='print' tableRef={componentRef.current}>
							Print
						</Button>
						<Button type='excel' tableRef={componentRef.current}>
							Excel
						</Button>
						<Instruction keyId={'fdcb'}></Instruction>
						<Button type='close' onClick={onClose}>
							Close
						</Button>
					</div>
				</div>
			</Header>

			<Body>
				{isLoading ? (
					<LoadingAnimation customHeight={700} customWidth={700} />
				) : (
					<div ref={componentRef} className='printable'>
						<img style={{ position: 'absolute', width: '80%', marginTop: 350, marginLeft: 100, marginRight: 200, opacity: 0.12, zIndex: -1 }} src={selectedCollege?.logo} />
						<div className='w-full flex flex-col rounded-[25px] p-[1%]'>
							<div className='w-full flex flex-row items-start gap-4 rounded-[25px]'>
								<img className='w-[50px] h-[50px] object-contain' src={selectedCollege?.logo} alt='College Logo' />

								<div className='flex flex-col text-left'>
									<span className='text-[20px] font-black dark:text-white'>{selectedCollege?.collegeShortName}</span>
									<p className='text-[25px] font-black m-0 dark:text-white'>{selectedCollege?.accreditedGrade}</p>
									<p className='text-[14px] font-black m-0 dark:text-white'>
										{state.mainAccountName} DCB Report as on {moment(new Date()).format('DD MMM YYYY hh:mm A')}
									</p>
								</div>
							</div>
							<Table width='100%' innerWidth={['5%', '15%', '20%', '20%', '10%', '10%', '10%']}>
								<Thead>
									<Tr>
										<Th position={0}>Sn</Th>
										<Th position={1}>Class Name</Th>
										<Th position={2}></Th>
										<Th position={3}></Th>
										<Th position={4}>Demand</Th>
										<Th position={5}>Collection</Th>
										<Th position={6}>Balance</Th>
									</Tr>
								</Thead>

								<Tbody>
									{data?.collections?.map((item, i) => (
										<Tr key={i}>
											<Td index={i} position={0}>
												{i + 1}
											</Td>
											<Td index={i} position={1}>
												{item?.className || ''}
											</Td>
											<Td index={i} position={2}>
												{item?.userName || ''}
											</Td>
											<Td index={i} position={3}>
												{item?.eGrantz?.isGrant || ''}
											</Td>
											<Td index={i} position={4}>
												{item?.openingBalance?.toFixed(2)}
											</Td>
											<Td index={i} position={5}>
												{item?.currentCollection?.toFixed(2)}
											</Td>
											<Td index={i} position={6}>
												{item?.clossingBalance?.toFixed(2)}
											</Td>
										</Tr>
									))}
								</Tbody>
							</Table>
							<h5 className='mt-10 text-right  text-[10px] dark:text-white'> Seal & Signature {moment(new Date()).format('DD MMM YYYY hh:mm A')}</h5>
						</div>
					</div>
				)}
			</Body>
		</Main>
	);
};
